<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Open House Settings</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" @change="getassschemedetails()" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Assessment Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="assessmenttype"
                            :items="assessment_type_list" item-text="assessmenttype" item-value="id"
                            label="Assessment Type" outlined persistent-hint hint="Please Select Assessment Type" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Standard</b></p>

                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="standard_id" label="Standard" multiple outlined
                            persistent-hint hint="Please Select Standard" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Open House Date</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="open_house_date"
                                    @blur="date = parseDate(open_house_date)" v-on="on" hint="From Date"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="house_date" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="2">
                        <br />
                        <v-checkbox v-model="checkbox">
                            <template v-slot:label>
                                <div>Show Report Card</div>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="save('open_house')" :loading="loader">Save</v-btn>
                </v-row>
            </v-card>
            <v-card class="box" v-if="open_house_list!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Open House Settings</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table :headers="headers" class="elevation-1 mytable" :items-per-page="-1" dense
                    :items="bookList1" @current-items="getFiltered">


                    <template v-slot:[`item.start_date`]="{ item }">
                        {{ item.start_date }}
                        <!-- <v-icon small class="v-icon-size" color="success" @click="changeDate(item)">mdi-pencil-outline</v-icon> -->
                        <v-avatar size="25" class="edit-avatar ml-5">
                            <v-icon class="mr-2 edit-v-icon" @click="changeDate(item)" title="edit">edit</v-icon>
                        </v-avatar>
                    </template>
                    <template v-slot:[`item.showreportcard`]="{ item }">
                        <span v-if="item.showreportcard">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <v-switch color="brand" v-model="item.showreportcard" @change="toggleShowReportCard(item)"></v-switch>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <v-icon class="mr-4 v-icon-size" color="red" @click="deleteOpenHouse(item)"
                            :loading="delete_attach_load">mdi-trash-can</v-icon>
                    </template>
                    <!-- filters added here -->
                    <template v-slot:top class="pb-5">
                        <v-row dense justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
            <v-card class="box" v-if="open_house_list != '' && add_update_exam_date">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Add / Update Exam Date</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" @change="getassschemedetails()" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Assessment Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="assessmenttype"
                            :items="assessment_type_list" item-text="assessmenttype" item-value="id"
                            label="Assessment Type" outlined persistent-hint hint="Please Select Assessment Type" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Standard</b></p>

                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="standard_id" label="Standard" multiple outlined
                            persistent-hint hint="Please Select Standard" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Exam Date</b></p>
                        <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="exam_start_date"
                                    @blur="date = parseDate(exam_start_date)" v-on="on" hint="Exam Start Date"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="exam_date" no-title @input="menu3 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="save('exam_date')" :loading="loader">Save</v-btn>
                </v-row>

                <v-data-table :headers="headers_exam" class="elevation-1 mytable" :items-per-page="-1" dense
                    :items="bookList1" @current-items="getFiltered">
                    <template v-slot:[`item.examdate`]="{ item }">
                        {{ item.examdate }}
                        <v-avatar size="25" class="edit-avatar ml-5">
                            <v-icon v-if="item.examdate" class="mr-2 edit-v-icon" @click="changeExamDate(item)"
                                title="edit">edit</v-icon>
                            <v-icon v-else class="mr-2 edit-v-icon" @click="changeExamDate(item)"
                                title="Add">mdi-plus</v-icon>
                        </v-avatar>
                    </template>
                    <template v-slot:top class="pb-5">
                        <v-row dense justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers_exam" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="6" md="6">
                                    <p><b>Update Open House Date</b></p>
                                    <v-dialog ref="dialog" v-model="modal1" :return-value.sync="date_edit" persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date_edit" rounded outlined dense
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date_edit" scrollable>
                                            <v-spacer></v-spacer><v-btn text color="primary"
                                                @click="modal1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(date_edit)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                                <v-btn class="button" @click="update()" :loading="loader">Update</v-btn>
                                <v-btn class="button" @click="dialog = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_exam_date" max-width="800px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="6" md="6">
                                    <p><b>Add / Update Exam Date</b></p>
                                    <v-dialog ref="dialog" v-model="modal3" :return-value.sync="date_exam" persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date_exam" rounded outlined dense
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date_exam" scrollable>
                                            <v-spacer></v-spacer><v-btn text color="primary"
                                                @click="modal3 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(date_exam)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                                <v-btn class="button" @click="update()" :loading="loader">Update</v-btn>
                                <v-btn class="button" @click="dialog_exam_date = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data: () => ({
          open_house_date: "",
          exam_start_date: "",
          house_date: new Date().toISOString().substr(0, 10),
          exam_date: new Date().toISOString().substr(0, 10),
          date_edit_marksheet: "",
          marksheet_date: new Date().toISOString().substr(0, 10),
        //   extraBreadcrumbItems: [


        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          delete_attach_load: false,
          loader: false,
          snackbar_msg: "",
          color: "",
          snackbar: false,
          ay_list: [],
          ay: "",
          standard_list: [],
          standard: [],
          open_house_list: [],
          assessment_type_list: [],
          assessmenttype: "",
          assessment: null,
          title: "",
          date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
          // date_edit_marksheet: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
          date_edit: "",
          date_exam:"",
          menu1: false,
          menu12: false,
          modal1: false,
          modal2: false,
          modal3:false,
          edit_openhouse_id: "",
          menu: false,
          modal: false,
          menu2: false,
          menu3:false,
          checkbox: false,
          dialog: false,
          add_update_exam_date:null,
          dialog_exam_date:false,
          headers: [
              { text: "Sr. No.", value: "srno" },
              { text: "Academic Year", value: "academicyear" },
              { text: "Assessment Type", value: "assessmenttype_config" },
              { text: "Standard", value: "standard" },
              { text: "Open House Date", value: "start_date" },
              { text: "Show Report Card", value: "showreportcard" },
              { text: "Edit", value: "edit" },
              { text: "Delete", value: "delete" },
          ],
          headers_exam: [
              { text: "Sr. No.", value: "srno" },
              { text: "Academic Year", value: "academicyear" },
              { text: "Assessment Type", value: "assessmenttype_config" },
              { text: "Standard", value: "standard" },
              { text: "Exam Date", value: "examdate" },
          ],
          filterArr: [],
          filters: {
              standard: [],
              assessmenttype_config: [],
              academicyear: [],
              // quota: [],
              // leaner: [],
              //
          },
      }),
      computed: {
          bookList1() {
              return this.open_house_list.filter((d) => {
                  return Object.keys(this.filters).every((f) => {
                      return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                  });
              });
          },
      },
      methods: {
          formatDate(date) {
              if (!date) return null;
              const [year, month, day] = date.split("-");
              return `${day}/${month}/${year}`;
          },
          parseDate(date) {
              if (!date) return null;
              const [month, day, year] = date.split("/");
              return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
          },
          getFiltered(e) {
              this.filterArr = e;
          },
          columnValueList(val) {
              return this.open_house_list.map((d) => d[val]);
          },
          deleteOpenHouse(item) {
              this.delete_attach_load = true;
              if (!confirm("Are you sure you want to delete This Record...?")) return;
              const formData = {
                  openhouse_id: item.id,
              };
              axios
                  .post("/Examination/deleteOpenHouseWws", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.showSnackbar("#4caf50", "Deleted Successfully"); // show snackbar on success
                          this.open_house_list = res.data.open_house_list;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.delete_attach_load = false;
                  });
          },
          update() {
              const formData = {
                  openhouse_id: this.edit_openhouse_id,
                  date_edit: this.date_edit,
                  date_exam:this.date_exam
              };
              axios
                  .post("/Examination/updateOpenHouseWws", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.showSnackbar("#4caf50", "Updated Successfully...");
                          this.open_house_list = res.data.open_house_list;
                          this.dialog = false;
                          this.dialog_exam_date = false;
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      this.loader = false;
                      this.dialog = false;
                  });
          },
          changeDate(item) {
              this.dialog = true;
              (this.date_edit = item.openhousedate_edit), (this.edit_openhouse_id = item.id);
          },
          changeExamDate(item) {
              this.dialog_exam_date = true;
              (this.date_exam = item.examdate_edit), (this.edit_openhouse_id = item.id);
          },
          toggleShowReportCard(item) {
              this.loader = true;
              const formData = {
                  open_house: item.id,
                  showreportcard: item.showreportcard,
              };
              axios
                  .post("/Examination/toggleShowReportCardWws", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.showSnackbar("#4caf50", "Updated Successfully...");
                          this.open_house_list = res.data.open_house_list;
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      this.loader = false;
                  });
          },
          save(type) {
              this.loader = true;
              if (this.ay == "" || this.ay == null) {
                  this.showSnackbar("#b71c1c", "Please Select Academic Year");
                  return;
              }
              if (this.assessmenttype == "" || this.assessmenttype == null) {
                  this.showSnackbar("#b71c1c", "Please Select Assessment Type");
                  return;
              }
              if (this.standard == "" || this.standard == null) {
                  this.showSnackbar("#b71c1c", "Please Select Standard");
                  return;
              }
              if(type == "open_house"){
                this.exam_start_date = ""
                if (this.open_house_date == "" || this.open_house_date == null) {
                    this.showSnackbar("#b71c1c", "Please Select Date");
                    return;
                }
              }
              if(type == "exam_date"){
                this.open_house_date = ""
                if (this.exam_start_date == "" || this.exam_start_date == null) {
                    this.showSnackbar("#b71c1c", "Please Select Date");
                    return;
                }
              }
              const formData = {
                  ay: this.ay,
                  standard: this.standard,
                  // date: this.date,
                  open_house_date: this.open_house_date,
                  exam_start_date: this.exam_start_date,
                  assessmenttype: this.assessmenttype,
                  showreportcard: this.checkbox,
              };
              axios
                  .post("/Examination/saveOpenHouseWws", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.showSnackbar("#4caf50", "Saved Successfully...");
                          this.open_house_list = res.data.open_house_list;
                      } else if (res.data.flag == "No") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      this.loader = false;
                      this.open_house_date = ""
                      this.exam_start_date = ""
                      this.assessmenttype = ""
                      this.standard = null
                  });
          },
          editDate() {
              this.loader = true;
              const formData = {
                  ay: this.ay,
                  standard: this.standard,
                  date: this.date_edit_marksheet,
                  assessment: this.assessment,
              };
              axios
                  .post("/Examination/editDateWws", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.showSnackbar("#4caf50", "Updated Successfully...");
                          this.loader = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong!");
                      this.loader = false;
                  })
                  .finally(() => {
                      this.loader = false;
                  });
          },

          getassschemedetails(){
                const data={
                    ay:this.ay
                }
                axios
                    .post("/WWSExamination/getassschemedetailsconfig",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_type_list = res.data.assessment_detail_list;
                        } 
                       else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },

          onLoad() {
              axios
                  .post("/Examination/openHouseWws")
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          (this.ay_list = res.data.ay_list),
                           (this.ay = res.data.curreny_ay), 
                           (this.standard_list = res.data.standard_list), 
                           (this.open_house_list = res.data.open_house_list);
                           this.add_update_exam_date = res.data.add_update_exam_date
                           this.getassschemedetails()
                        //  this.assessment_type_list = res.data.assessment_type_list;
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },

          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {
          this.onLoad();
          this.open_house_date = this.formatDate(this.house_date);
          this.exam_start_date = this.formatDate(this.exam_date);
          this.date_edit_marksheet = this.formatDate(this.marksheet_date);
      },
      watch: {
          house_date(val) {
              this.open_house_date = this.formatDate(this.house_date);
          },
          exam_date(val) {
              this.exam_start_date = this.formatDate(this.exam_date);
          },
          marksheet_date(val) {
              this.date_edit_marksheet = this.formatDate(this.marksheet_date);
          },
      },
  };
</script>
<style scoped>
  .v-icon-size {
      font-size: 20px;
  }
  .edit-avatar {
      transition: 0.3s;
      border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
      background-color: #b0bec5;
  }
  .edit-v-icon {
      padding-left: 6px;
      font-size: 15px;
  }
  .edit-v-icon:hover {
      color: white;
  }
</style>
